// Renders a single domino tile with pip dots.
const DOT_MAP = {
  0: [],
  1: [4],
  2: [0, 8],
  3: [0, 4, 8],
  4: [0, 2, 6, 8],
  5: [0, 2, 4, 6, 8],
  6: [0, 2, 3, 5, 6, 8],
};

function Pips({ value }) {
  const dots = DOT_MAP[value] || [];
  return (
    <div className="grid grid-cols-3 grid-rows-3 gap-[2px] w-full h-full p-[10%]">
      {Array.from({ length: 9 }).map((_, i) => (
        <div key={i} className="flex items-center justify-center">
          {dots.includes(i) && (
            <span className="block rounded-full bg-[#111827]" style={{ width: "78%", height: "78%" }} />
          )}
        </div>
      ))}
    </div>
  );
}

export function DominoTile({ left, right, orientation = "v", size = 44, playable, selected, onClick, dim, corner, last, testid }) {
  const isH = orientation === "h";
  const long = size;
  const short = size / 2;
  const w = isH ? long : short;
  const h = isH ? short : long;
  const clickable = !!onClick;
  return (
    <button
      type={clickable ? "button" : undefined}
      onClick={onClick}
      data-testid={testid}
      className={`relative shrink-0 rounded-lg transition-transform duration-150 ${clickable ? "cursor-pointer hover:-translate-y-1" : "cursor-default"} ${selected ? "-translate-y-2" : ""} ${playable ? "ring-2 ring-[#10B981] shadow-[0_0_14px_rgba(16,185,129,0.7)] pulse-green" : ""} ${corner ? "ring-2 ring-[#D4AF37]/80 shadow-[0_0_12px_rgba(212,175,55,0.6)]" : ""} ${last && !corner ? "ring-2 ring-[#F3E5AB]/70" : ""} ${dim ? "opacity-45" : ""}`}
      style={{
        width: w, height: h,
        background: "linear-gradient(160deg,#FFFFFF 0%,#F7F2E9 48%,#E9E1D0 100%)",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.9), inset 0 -2px 3px rgba(0,0,0,0.10), 0 3px 0 rgba(0,0,0,0.35), 0 6px 14px rgba(0,0,0,0.45)",
      }}
    >
      <div className={`w-full h-full flex ${isH ? "flex-row" : "flex-col"}`}>
        <div className={`${isH ? "h-full" : "w-full"} flex-1 relative`}>
          <Pips value={left} />
        </div>
        <div className={`${isH ? "w-[2px] h-[78%] my-auto" : "h-[2px] w-[78%] mx-auto"} bg-gradient-to-r from-transparent via-[#C99A2E] to-transparent`} />
        <div className={`${isH ? "h-full" : "w-full"} flex-1 relative`}>
          <Pips value={right} />
        </div>
      </div>
    </button>
  );
}
